<form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">
  <section class="rounded-2xl border border-gray-200 bg-white p-5 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
    <h2 class="mb-4 text-sm font-semibold text-gray-800 dark:text-white/90">Définition</h2>
    <div class="space-y-4">
      <div>
        <label for="role-name" class="mb-1.5 block text-xs font-medium text-gray-700 dark:text-gray-400">
          Nom <span class="text-error-500">*</span>
          @if (mode === 'edit') {
            <span class="ml-1 text-[10px] font-normal text-gray-400">(non modifiable)</span>
          }
        </label>
        <input
          id="role-name"
          type="text"
          formControlName="name"
          placeholder="ex. ADMIN, OPERATOR, my_custom_role"
          autocomplete="off"
          class="h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 font-mono text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/20 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
          [class.border-error-500]="showError('name')"
          [class.border-gray-300]="!showError('name')"
          [class.dark:border-gray-700]="!showError('name')"
        />
        @if (errorFor('name'); as msg) {
          <p class="mt-1.5 text-xs text-error-500">{{ msg }}</p>
        } @else {
          <p class="mt-1.5 text-xs text-gray-500 dark:text-gray-400">
            Convention Nawam : rôles métier en MAJUSCULES (ex. ADMIN), rôles techniques en snake_case.
          </p>
        }
      </div>

      <div>
        <label for="role-description" class="mb-1.5 block text-xs font-medium text-gray-700 dark:text-gray-400">
          Description
        </label>
        <input
          id="role-description"
          type="text"
          formControlName="description"
          placeholder="À quoi sert ce rôle"
          class="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/20 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
        />
        @if (errorFor('description'); as msg) {
          <p class="mt-1.5 text-xs text-error-500">{{ msg }}</p>
        }
      </div>

      <label class="inline-flex cursor-pointer items-center gap-3">
        <input type="checkbox" formControlName="composite" class="peer sr-only" />
        <span class="relative h-6 w-11 rounded-full bg-gray-200 transition peer-checked:bg-brand-500 dark:bg-gray-700">
          <span class="absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-white shadow-theme-xs transition peer-checked:translate-x-5"></span>
        </span>
        <span class="text-sm text-gray-700 dark:text-gray-300">
          Rôle composite (contient d'autres rôles)
        </span>
      </label>
    </div>
  </section>

  @if (serverError) {
    <div class="rounded-lg border border-error-200 bg-error-50 px-4 py-3 text-sm text-error-700 dark:border-error-800 dark:bg-error-500/10 dark:text-error-400">
      {{ serverError }}
    </div>
  }

  <div class="flex flex-col-reverse items-stretch gap-3 sm:flex-row sm:items-center sm:justify-end">
    <button
      type="button"
      (click)="onCancel()"
      [disabled]="submitting"
      class="rounded-lg border border-gray-300 px-5 py-2.5 text-sm font-medium text-gray-700 transition hover:bg-gray-50 disabled:opacity-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/5"
    >
      Annuler
    </button>
    <button
      type="submit"
      [disabled]="submitting || form.invalid"
      class="inline-flex items-center justify-center gap-2 rounded-lg bg-brand-500 px-5 py-2.5 text-sm font-medium text-white shadow-theme-xs transition hover:bg-brand-600 disabled:cursor-not-allowed disabled:bg-brand-300"
    >
      @if (submitting) {
        <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" stroke-opacity="0.25" />
          <path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
        </svg>
        Enregistrement…
      } @else {
        @if (mode === 'create') { Créer le rôle } @else { Enregistrer }
      }
    </button>
  </div>
</form>
